module.exports = __webpack_public_path__ + "static/media/30.576087fc.jpg";